import {
  DRIVE_ERROR_MESSAGES,
  ensureProjectFolder,
  shareFileWithLink,
  uploadFileToDrive,
  withDriveToken,
} from '../files/drive';
import type { SupabaseClient } from '../../lib/supabase';

/**
 * A copy set's photo has to outlive the person who added it: the next sender
 * needs the same picture. So it goes to Drive — one folder in the uploader's
 * own Drive, the same way client proofs and sample photos are kept — and the
 * body records `drive:<id>`. Shared by link so every signed-in colleague can
 * read the bytes at send time with their own Drive access (resolvePhotos).
 */
export const COPY_LIBRARY_PHOTO_FOLDER = 'TAP Hub — Copy Library Photos';

export async function uploadCopySetPhoto(
  client: SupabaseClient,
  file: File,
): Promise<{ ref: string; caption: string }> {
  if (!file.type.startsWith('image/')) {
    throw new Error('Only a picture can go in the body of an email.');
  }
  const id = await withDriveToken(client, async (token) => {
    const folderId = await ensureProjectFolder(token, 'root', COPY_LIBRARY_PHOTO_FOLDER);
    const uploaded = await uploadFileToDrive(token, folderId, file);
    await shareFileWithLink(token, uploaded.id);
    return uploaded.id;
  });
  return { ref: `drive:${id}`, caption: file.name.replace(/\.[a-z0-9]+$/i, '') };
}

export function copySetPhotoErrorMessage(message: string): string {
  return DRIVE_ERROR_MESSAGES[message] ?? message;
}
